var text_field_default = {
  "root": "GKOmD",
  "text": "Ed61V",
  "input": "l3Zl4",
  "small": "mWI6J",
  "medium": "_0Q7d4",
  "large": "Y-sIx",
  "webview": "UoYQw",
  "endAdornment": "Y-EHR",
  "shown": "NHKl7",
  "value": "_9vaIj",
  "spinner": "_2Fg76",
  "spin": "_9UxiG"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
